import { useCallback, useState } from "react";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import { store } from "../redux/store";

export function useRedux() {
  // Infer the `RootState` and `AppDispatch` types from the store itself
  type RootState = ReturnType<typeof store.getState>;
  // Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
  type AppDispatch = typeof store.dispatch;
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const useAppDispatch: () => AppDispatch = useDispatch;
  const dispatch = useAppDispatch();
  const state = store.getState();
  return {
    dispatch,
    useAppDispatch,
    data: state.client,
  };
}
